// components/clients/PeriodTabs.jsx
import React from 'react';

// Onglets de période de l'écran clientes (pilotés par le param `period` de l'URL).
export const PeriodTabs = ({ periods, value, onChange }) => (
  <div className="mobile-client-periods" role="tablist">
    {periods.map((item) => (
      <button
        type="button"
        key={item.key}
        className={value === item.key ? 'is-active' : ''}
        onClick={() => onChange(item.key)}
      >
        {item.label}
      </button>
    ))}
  </div>
);
